import { render } from "./PlanVencido.vue?vue&type=template&id=21da1898&scoped=true"
import script from "./PlanVencido.vue?vue&type=script&lang=js"
export * from "./PlanVencido.vue?vue&type=script&lang=js"

import "./PlanVencido.vue?vue&type=style&index=0&id=21da1898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21da1898"]])

export default __exports__